import { TCAPLoader } from '../../TCAPLoader';

/**
 * TCAPLoadingOverlay
 * AG Grid loading overlay wrapper component.
 * @param {boolean} darkMode - Toggles between dark and light themes.
 * @param {string} loadingMessage - Text to display (default: 'Loading')
 * @param {number} scale - Multiplier for component size (default: 1)
 */
const TCAPLoadingOverlay = (props) => {
    const { darkMode, loadingMessage = 'Loading', scale = 1 } = props;

    return (
        <TCAPLoader
            variant={darkMode ? 'dark' : 'light'}
            text={loadingMessage}
            scale={scale}
        />
    );
};

export default TCAPLoadingOverlay;
